import type { GetAppointmentQuery } from '@models/generated/graphql'
import { TimeStatus } from '@models/generated/graphql'

/**
 * Mock appointment data for demo/development purposes
 * Used in demo routes to work without backend
 */
export const mockAppointment: NonNullable<GetAppointmentQuery['appointment']> = {
  __typename: 'ImmersionAppointment',
  id: 'demo-appointment-123',
  conversationId: 'demo-conversation-123',
  from: new Date().toISOString(),
  to: new Date(Date.now() + 1800000).toISOString(), // 30 minutes from now
  timeStatus: TimeStatus.Future,
  hasInterlocutorJoined: Math.random() < 0.5,
  chimeAttendeeData: {
    AttendeeId: 'demo-attendee-id-456',
    ExternalUserId: 'demo-external-user',
    JoinToken: 'demo-join-token'
  },
  chimeMeetingData: {
    MeetingId: 'demo-meeting-id-123',
    MediaRegion: 'eu-central-1',
    MediaPlacement: {
      AudioHostUrl: 'demo-audio-host',
      AudioFallbackUrl: 'demo-audio-fallback',
      ScreenDataUrl: 'demo-screen-data',
      ScreenSharingUrl: 'demo-screen-sharing',
      ScreenViewingUrl: 'demo-screen-viewing',
      SignalingUrl: 'demo-signaling',
      TurnControlUrl: 'demo-turn-control'
    }
  },
  me: {
    __typename: 'PublicProfessionalProfile',
    firstName: 'Marie',
    lastName: 'Dupont',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marie'
  },
  interlocutor: {
    __typename: 'PublicStudentProfile',
    firstName: 'Thomas',
    lastName: 'Martin',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Thomas'
  }
}

/**
 * Mock Chime meeting configuration for demo purposes
 * Simulates the response from appointment query
 */
export const mockChimeMeetingConfig = {
  meeting: mockAppointment.chimeMeetingData,
  attendee: mockAppointment.chimeAttendeeData,
  expiresAt: new Date(Date.now() + 3600000).toISOString() // 1 hour from now
}

/**
 * Mock loader data structure for PrejoinDemo component
 */
export const mockPreJoinLoaderData = {
  appointment: mockAppointment
}
